import { FC } from 'react';

import {
  FeatureFlagDisplay,
  LoginSwitchPage,
  NativeLoginPage,
} from '@app/components';
import { Feature } from '@app/constants';

export const LoginPage: FC = () => (
  <FeatureFlagDisplay
    flagToMatch={{ name: Feature.consortiaLoginFlow }}
    renderOn={() => <LoginSwitchPage />}
    renderOff={() => <NativeLoginPage />}
  />
);
